export class FindAllOrganisationRolesError {
  public static readonly type =
    '[Organisation/OrganisationRoles/List] FindAllOrganisationRolesError';
  constructor(public readonly error: Error) {}
}
